import { CheckboxOption, Offset } from '@uc/web/shared/data-models';
import {
	EventsFilterOptions,
	EventsSearchPayload,
	EventsSearchQueryParams,
} from '../models/open-days.models';

/**
 * @param payload from store that were sent with previous query
 * @param queryParams from store
 * @param filters from store, options that the filter displays for the checkboxes
 * @returns updated backend args
 */
export const generatePayload = (
	payload: EventsSearchPayload,
	queryParams: EventsSearchQueryParams,
	filters: EventsFilterOptions,
): EventsSearchPayload => {
	const searchString = formatSearchString(queryParams.s);
	const dateFrom = queryParams.date ? queryParams.date.split('_')[0] : null;
	const dateTo = queryParams.date ? queryParams.date.split('_')[1] : null;
	const typeIds = getQueryParamsIdByUrlName(queryParams.type, filters.types);
	const locationIds = getQueryParamsIdByUrlName(queryParams.loc, filters.locations);
	const page = checkIfPageValid(queryParams.page);
	const product = queryParams.level ?? 'undergraduate';

	return {
		...payload,
		name: searchString,
		dateFrom,
		dateTo,
		typeIds,
		locationIds,
		product,
		page,
		offset: page ? Offset.Off : Offset.On, // 1 - get 20 for current page; 0 - page * 20. To be used when I do the load more btn.
	};
};

const checkIfPageValid = (pageQueryParamValue: string | undefined) => {
	if (!pageQueryParamValue) return 1;

	const page = parseInt(pageQueryParamValue, 10);
	if (isNaN(page)) return 1;

	return page;
};

/**
 * @param queryParamValue e.g. "ldn" for location representing London
 * @param arrayOfFilterOptions options for the specific filter, e.g. the values that location can have
 * @returns an array of IDs for the selected filter options
 */
const getQueryParamsIdByUrlName = (
	queryParamValue: string | undefined,
	arrayOfFilterOptions: CheckboxOption[] | undefined,
) => {
	if (!queryParamValue || !arrayOfFilterOptions) return [];

	const arrayOfParams = queryParamValue.split('_');
	const ids: number[] = [];

	arrayOfParams.forEach((param) => {
		const found = arrayOfFilterOptions.find((option) => option.url_name === param);
		if (found) ids.push(found.id);
	});

	return ids;
};

const formatSearchString = (searchString: string | undefined) => {
	if (!searchString) return '';
	return searchString.trim().toLowerCase().replace(/-/g, ' ');
};
